<template>
  <div>
    <div ref="listRef" class="timeline-block"><slot name="items"></slot></div>
    <button
      v-if="canShowMore"
      role="button"
      aria-label="Load more"
      class="button button--outlined"
      @click="showMoreHandler"
    >
      Show more
    </button>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';

const pageNumberRef = ref(0);
const listRef = ref();
const listItemsRef = ref([]);
const canShowMore = ref(false);

const props = defineProps({
  visibleOnPageLoad: {
    type: Number,
    default: 2,
  },
  showPerStep: {
    type: Number,
    default: 2,
  },
});

const showListItemsHandler = () => {

  const lastItem = listRef.value.querySelector('.last-before-load-more-button')
  if (lastItem) {
    lastItem.classList.remove('last-before-load-more-button')
  }
 
  const itemsToShow =
    props.visibleOnPageLoad + pageNumberRef.value * props.showPerStep;
  const selectedItems = listItemsRef.value.slice(0, itemsToShow);
  selectedItems.forEach((element) => {
    element.style.display = 'block';
  });

  const newLastItem = selectedItems[selectedItems.length - 1]
  if (newLastItem) {
    newLastItem.classList.add('last-before-load-more-button')
  }

  if (selectedItems.length < listItemsRef.value.length) {
    canShowMore.value = true;
  } else {
    canShowMore.value = false;
  }
};

onMounted(() => {
  const childUl = listRef.value.querySelector('ul')
  listItemsRef.value = childUl ?  Array.from(childUl.querySelectorAll(':scope > li')) : [];
  showListItemsHandler();
});

const showMoreHandler = () => {
  pageNumberRef.value += 1;
  showListItemsHandler();
};
</script>
